import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Play, Heart } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-sky-blue/30 via-white to-bobo-green/30">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-4 -left-4 w-72 h-72 bg-teedee-blue/20 rounded-full blur-3xl animate-float"></div>
        <div className="absolute -bottom-8 -right-8 w-96 h-96 bg-bobo-green/20 rounded-full blur-3xl animate-bounce-gentle"></div>
        <div
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-brand-purple/10 rounded-full blur-3xl animate-float"
          style={{ animationDelay: "1s" }}
        ></div>
      </div>

      <div className="relative py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Content */}
            <div className="text-center lg:text-left">
              <h1 className="text-4xl lg:text-6xl xl:text-7xl font-bold mb-6">
                <span className="text-teedee-blue">Welcome to</span>
                <br />
                <span className="text-bobo-green">Bobo & Teedee®</span>
              </h1>

              <p className="text-lg lg:text-xl xl:text-2xl text-gray-700 mb-8 leading-relaxed">
                Join Bobo the turtle and Teedee the iguana on magical
                educational adventures exploring the beautiful{" "}
                <span className="text-teedee-blue font-semibold">
                  Cayman Islands
                </span>
                !
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
                <Button
                  asChild
                  size="lg"
                  className="bg-teedee-blue hover:bg-teedee-blue/90 text-white text-lg px-8 py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
                >
                  <Link to="/episodes">
                    <Play className="mr-3 h-5 w-5" />
                    Watch Episodes
                  </Link>
                </Button>

                <Button
                  asChild
                  variant="outline"
                  size="lg"
                  className="border-2 border-bobo-green text-bobo-green hover:bg-bobo-green hover:text-white text-lg px-8 py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
                >
                  <Link to="/about">
                    <Heart className="mr-3 h-5 w-5" />
                    Meet the Characters
                  </Link>
                </Button>
              </div>

              {/* Fun Stats */}
              <div className="grid grid-cols-3 gap-4 p-6 bg-white/70 backdrop-blur-sm rounded-2xl shadow-xl">
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold text-teedee-blue">
                    10+
                  </div>
                  <div className="text-sm text-gray-600">Episodes</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold text-bobo-green">
                    100K+
                  </div>
                  <div className="text-sm text-gray-600">Happy Kids</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold text-brand-purple">
                    🇰🇾
                  </div>
                  <div className="text-sm text-gray-600">Cayman Made</div>
                </div>
              </div>
            </div>

            {/* Characters Image */}
            <div className="relative">
              <div className="relative z-10 transform hover:scale-105 transition-transform duration-300">
                <img
                  src="/img/bobo-teedee-logo.png"
                  alt="Bobo the turtle and Teedee the iguana - educational cartoon characters from the Cayman Islands"
                  className="w-full max-w-lg mx-auto drop-shadow-2xl"
                />
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-6 -right-6 w-12 h-12 bg-golden-orange rounded-full animate-bounce-gentle opacity-80"></div>
              <div
                className="absolute -bottom-4 -left-4 w-8 h-8 bg-brand-purple rounded-full animate-float opacity-60"
                style={{ animationDelay: "2s" }}
              ></div>
              <div
                className="absolute top-1/4 -right-8 w-6 h-6 bg-sky-blue rounded-full animate-bounce-gentle opacity-70"
                style={{ animationDelay: "0.5s" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
